import React, { useState, useEffect } from 'react';

import TextInput from '../../../Form/TextInput';
import CurrencyInput from '../../../Form/CurrencyInput';
import Currency from '../Currency';

export default function OptionalTextInput({
  inputType,
  initialValue,
  onChange,
  readOnly,
  compact,
}) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    onChange(value);
  }, [onChange, value]);

  const inputProps = {
    value,
    onChange: (event) => setValue(event.target.value),
    readOnly,
    compact,
  };

  if (value === '-' && inputType === 'currency') {
    return <div>-</div>;
  }

  if (inputType === 'currency' && readOnly) {
    return <Currency compact={compact} value={value} />;
  }

  return (
    <div className="w-44">
      {inputType === 'currency' ? (
        <CurrencyInput {...inputProps} />
      ) : (
        <TextInput {...inputProps} />
      )}
    </div>
  );
}
